module.exports = __webpack_public_path__ + "static/media/o2o_img_01.fc8bada0.jpg";